module.exports = __webpack_public_path__ + "static/media/familyPortrait79.08ce8e61.png";